import * as React from 'react';

function OrderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09 3.99a2.53 2.53 0 0 1 1.788-.74h11.555a2.53 2.53 0 0 1 2.528 2.528v9.917h1.917a.75.75 0 0 1 .75.75v1.777A2.53 2.53 0 0 1 19.1 20.75H8.433a2.53 2.53 0 0 1-2.527-2.528v-9.04a1 1 0 0 1-.14.012H3.1a.75.75 0 0 1-.75-.75V5.778c0-.67.266-1.314.74-1.788m2.816 3.717v-1.93a1.028 1.028 0 0 0-2.056 0v1.917h1.917q.071 0 .139.013M7.187 4.75c.143.32.219.67.219 1.028v12.444a1.028 1.028 0 0 0 2.055 0v-1.777a.75.75 0 0 1 .75-.75h7.25V5.778a1.03 1.03 0 0 0-1.028-1.028zm3.774 12.445v1.027c0 .358-.076.707-.218 1.028H19.1a1.03 1.03 0 0 0 1.028-1.028v-1.027z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1 8.125a.75.75 0 0 1 .75-.75h3.3a.75.75 0 0 1 0 1.5h-3.3a.75.75 0 0 1-.75-.75m0 4.125a.75.75 0 0 1 .75-.75h3.3a.75.75 0 0 1 0 1.5h-3.3a.75.75 0 0 1-.75-.75M8.8 8.125a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 0 1.5H9.55a.75.75 0 0 1-.75-.75m0 4.125a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 0 1.5H9.55a.75.75 0 0 1-.75-.75"
  }));
}

export { OrderIcon };
